import C from 'actionTypes'

export const setPrimaryPortfolio = data => ({
  type: C.SET_PRIMARY_PORTFOLIO_DETAILS,
  data
})

export const setPrimaryPortfolioAccounts = data => ({
  type: C.SET_PRIMARY_PORTFOLIO_ACCOUNTS,
  data
})

export const setPrimaryPortfolioClassAllocations = (data, portfolioId) => ({
  type: C.SET_PRIMARY_PORTOFLIO_CLASS_ALLOCATIONS,
  data: {
    id: portfolioId,
    classAllocations: data.data
  }
})

export const setPrimaryPortfolioHoldings = (data, portfolioId) => ({
  type: C.SET_PRIMARY_PORTOFLIO_HOLDINGS,
  data: {
    id: portfolioId,
    holdings: data.data
  }
})

export default {
  setPrimaryPortfolio,
  setPrimaryPortfolioAccounts,
  setPrimaryPortfolioClassAllocations,
  setPrimaryPortfolioHoldings,
}



// WEBPACK FOOTER //
// ./src/actions/client/primaryPortfolio.js